<template>
	<div class="content">
		<div class="flex" style="max-width: 1100px">
			<div class="box" v-for="(item, index) in tableList" :key="index">
				<div class="box-top">
					<img :src="item.image.url" alt="" />
				</div>
				<div class="box-bottom">{{ item.name }}</div>
				<div style="position: absolute; bottom: 8px; right: 8px">
					<el-switch
						v-model="item.textStatus"
						active-color="#13ce66"
						inactive-color="#ff4949"
						@change="amend(index, item.id, item.textStatus)"
					>
					</el-switch>
				</div>
				<el-button
					type="text"
					style="position: absolute; top: 8px; left: 8px"
					v-if="butArry.indexOf(item.payment_code) > -1"
					@click="go(item.payment_code)"
				>
					进入配置
				</el-button>
				<el-button
					size="small"
					type="danger"
					style="position: absolute; top: 0px; right: 0px"
					v-if="item.payment_code == 'unionpay'"
				>
					推荐
				</el-button>
			</div>
		</div>
		<el-dialog
			:visible.sync="dialogVisible"
			width="14%"
			:title="msg"
			:destroy-on-close="true"
			@close="close"
			top="30vh"
		>
			<el-button v-if="msg == '已授权'" @click="cxsq">重新授权</el-button>
			<div id="qrcode" ref="qrcode" style="margin: 10px" v-else></div>
		</el-dialog>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import { fuiouInfo, payStatus, payType } from "@/api/pay";
import { authorizeMerchat, GetAliMiniConfigInfo, setAliMiniConfigInfo } from "@/api/configuration";
import QRCode from "qrcodejs2";

export default {
	inject: ["reload"],
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	data() {
		return {
			msg: "",
			loading: true,
			sq: "",
			dialogVisible: false,
			butArry: [
				"single_wxpay",
				"unionpay",
				"allinpay",
				"balance",
				"single_alipay",
				"alipay",
        "fuiou"
			],
			tableList: [],
			pathData: [
				{
					payment_code: "single_wxpay",
					url: "/apply/newVip/13/pay/null/weixin",
				},
				{
					payment_code: "single_alipay",
					url: "/apply/newVip/13/pay/null/zhifubao",
				},
				{
					payment_code: "unionpay",
					url: "/apply/newVip/13/pay/null/yinlian",
				},
				{
					payment_code: "allinpay",
					url: "/apply/newVip/13/pay/null/tonglian",
				},
				{
					payment_code: "balance",
					url: "/apply/newVip/13/pay/null/balance",
				},
			],
			timer: null,
		};
	},
	mounted() {
		this.getList();
	},
	methods: {
		go(path) {
			console.log("path", path);
			this.pathData.forEach((element) => {
				if (element.payment_code == path) {
					this.$router.push(element.url);
				}
			});
			if (path == "alipay") {
				this.GetAliMiniConfigInfo();
				// console.log('panduan2',res)
			}
      if (path == "fuiou") {
        fuiouInfo({app_id:this.app_id}).then(res => {
          console.log("unionData: ", res);
          if (res.code == 200) {
            this.$router.push('/apply/newVip/13/pay/null/fuiou');
          } else {
            this.$message.warning(res.msg);
          }
        })
      }
		},
		getList() {
			// this.page++;
			let data = {
				token: this.token,
				app_id: this.app_id,
				// page: this.page,
			};
			payType(data).then((res) => {
				console.log("列表", res);
				if (res.code == 200) {
					this.tableList = res.data;
					this.tableList.forEach((element) => {
						// element.checked = element.textStatus ? 1 : 0;
						element.textStatus = element.checked == 1 ? true : false;
					});
				}
				console.log("new   ", this.tableList);
			});
		},

		// 修改状态
		amend(index, id, status) {
			console.log("修改状态", index, id, status);
			var newStatus = status ? 1 : 0;
			this.$confirm("确认修改吗？")
				.then(() => {
					let data = {
						token: this.token,
						app_id: this.app_id,
						open: newStatus,
						type_id: id,
					};
					payStatus(data).then((res) => {
						if (res.code == 200) {
							this.$message.success("修改成功");
							this.reload();
						} else {
							this.$message.error(res.msg);
						}
					});
				})
				.catch(() => {
					this.tableList[index].newStatus = !status;
				});
		},
		//重新授权
		cxsq() {
			// this.sq = "未授权";
			if (this.sq == "已授权") {
				this.$confirm("重新授权前请先解除之前授权! 是否解除授权!", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				})
					.then(() => {
						this.jiechu();
					})
					.catch(() => {
						this.dialogVisible = false;
					});
			}
			// authorizeMerchat({ app_id: this.app_id }).then((res) => {
			// 	if (res.code == 200) {
			// 		let url = res.data.url;
			// 		console.log(res.data.url);
			// 		this.qrcode(url);
			// 	}
			// });
		},
		close() {
			clearInterval(this.timer);
		},
		async jiechu() {
			try {
				const res = await setAliMiniConfigInfo({
					app_id: this.app_id,
					type: 2,
				});
				if (res.code == 200) {
					console.log(res);
					this.$message.success(res.msg);
					this.msg = "未授权";
					const res2 = await authorizeMerchat({ app_id: this.app_id });
					if (res2.code == 200) {
						this.dialogVisible = true;
						this.$nextTick(() => {
							this.qrcode(res2.data.url);
						});
					}
				}
			} catch (e) {
				console.log(e);
			}
		},
		//二维码
		qrcode(url) {
			try {
				let qrcode = new QRCode("qrcode", {
					width: 200, // 设置宽度，单位像素
					height: 200, // 设置高度，单位像素
					text: url, // 设置二维码内容或跳转地址
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: 3,
				});
				if (this.msg == "未授权") {
					this.timer = setInterval(() => {
						GetAliMiniConfigInfo({
							token: this.token,
							app_id: this.app_id,
							type: 2,
						}).then((res) => {
							if (res.code == 200) {
								clearInterval(this.timer);
								this.timer = null;
								this.$message.success(res.msg);
								this.$nextTick(() => {
									this.dialogVisible = false;
								});
							}
						});
					}, 2000);
				}
			} catch (e) {
				console.log(e);
			}
		},
		async GetAliMiniConfigInfo() {
			try {
				console.log("shouquan");
				const resonpes = await GetAliMiniConfigInfo({
					token: this.token,
					app_id: this.app_id,
					type: 2,
				});
				console.log(resonpes);
				if (resonpes.code == 400) {
					this.msg = resonpes.msg;
					this.sq = resonpes.msg;
					// this.dialogVisible = true;
					const res = await authorizeMerchat({ app_id: this.app_id });
					if (res.code == 200) {
						this.dialogVisible = true;
						this.$nextTick(() => {
							this.qrcode(res.data.url);
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					// this.getList()
					this.msg = resonpes.msg;
					this.sq = resonpes.msg;
					this.dialogVisible = true;
					// this.$message.success(resonpes.msg);
				}
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.content {
	padding: 20px 26px 11px 20px;
	height: 100vh;
	border: 1px solid #f1f1f1;
	overflow: auto;
	min-width: 900px;
	background: rgba(240, 242, 245, 1);
	.flex {
		display: flex;
		flex-wrap: wrap;
	}
	.box {
		width: 317px;
		height: 174px;
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		margin: 0 15px 15px 0;
		text-align: center;
		font-size: 14px;
		position: relative;
		.box-top {
			height: 107px;
		}
		img {
			width: 44px;
			margin-top: 47px;
		}
	}
}
</style>
